import { useEffect, useState } from 'react';
import { Card, Button, Typography } from 'antd';
import { startSsoLogin } from '../api/oidc';

export default function LoginPage() {
  const [fallback, setFallback] = useState(false);

  // Единая страница входа — Keycloak SSO (v2.2.0: локального входа больше нет)
  useEffect(() => {
    if (!sessionStorage.getItem('oidc_back_to_local')) {
      startSsoLogin();
    }
  }, []);

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      position: 'relative',
      overflow: 'hidden',
    }}>
      <div style={{
        position: 'absolute',
        top: '-50%',
        left: '-50%',
        width: '200%',
        height: '200%',
        background: 'radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px)',
        backgroundSize: '50px 50px',
        animation: 'moveGrid 20s linear infinite',
      }} />
      
      <style>{`
        @keyframes moveGrid {
          0% { transform: translate(0, 0); }
          100% { transform: translate(50px, 50px); }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        .login-card {
          animation: float 6s ease-in-out infinite;
        }
      `}</style>
      
      <div style={{ 
        position: 'relative', 
        zIndex: 1,
        width: '100%',
        maxWidth: 440,
        padding: '0 20px',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{
            width: 80,
            height: 80,
            margin: '0 auto 20px',
            borderRadius: 20,
            background: 'rgba(255, 255, 255, 0.2)',
            backdropFilter: 'blur(10px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 36,
            fontWeight: 700,
            color: 'white',
            border: '1px solid rgba(255, 255, 255, 0.3)',
          }}>
            ТС
          </div>
          <Typography.Title style={{ 
            color: 'white', 
            margin: 0,
            fontSize: 32,
            fontWeight: 700,
            textShadow: '0 2px 10px rgba(0,0,0,0.2)',
          }}>
            ТЕРРА-СУП
          </Typography.Title>
          <Typography.Text style={{ 
            color: 'rgba(255, 255, 255, 0.8)',
            fontSize: 16,
            display: 'block',
            marginTop: 8,
          }}>
            Система управления проектами
          </Typography.Text>
        </div>
        
        <Card 
          className="login-card"
          style={{ 
            borderRadius: 24,
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
          }}
          styles={{ body: { padding: 32 } }}
        >
          {!fallback ? (
            <div style={{ textAlign: 'center', padding: '12px 0' }}>
              <Typography.Text style={{ display: 'block', marginBottom: 20, color: '#64748b' }}>
                Переходим на единую страницу входа…
              </Typography.Text>
              <Button
                block
                onClick={() => {
                  sessionStorage.setItem('oidc_back_to_local', '1');
                  setFallback(true);
                }}
                style={{ height: 48, borderRadius: 12 }}
              >
                Не перенаправляет? Повторить вход
              </Button>
            </div>
          ) : (
          <div style={{ textAlign: 'center', padding: '12px 0' }}>
            <Typography.Text style={{ display: 'block', marginBottom: 20, color: '#64748b' }}>
              Вход в ТЕРРА-СУП выполняется через единую страницу входа.
            </Typography.Text>
            <Button
              block
              type="primary"
              onClick={() => {
                sessionStorage.removeItem('oidc_back_to_local');
                startSsoLogin();
              }}
              style={{ height: 48, borderRadius: 12, background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)' }}
            >
              Перейти к единому входу
            </Button>
          </div>
          )}
        </Card>
        
        <div style={{ textAlign: 'center', marginTop: 24 }}>
          <Typography.Text style={{ color: 'rgba(255, 255, 255, 0.6)', fontSize: 13 }}>
            © 2024 ТЕРРА-СУП. Все права защищены.
          </Typography.Text>
        </div>
      </div>
    </div>
  );
}
